"use client"

import * as React from "react"
import { Tooltip as TooltipPrimitive } from "radix-ui"

import { cn } from "@/custolink-newdesign/lib/utils"

function TooltipProvider({
  delayDuration = 0,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  )
}

function Tooltip({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return <TooltipPrimitive.Root data-slot="tooltip" {...props} />
}

function TooltipTrigger({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />
}

function TooltipContent({
  className,
  sideOffset = 0,
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          "cl:z-50 cl:w-fit cl:origin-(--radix-tooltip-content-transform-origin) cl:animate-in cl:rounded-md cl:bg-foreground cl:px-3 cl:py-1.5 cl:text-xs cl:text-balance cl:text-background cl:fade-in-0 cl:zoom-in-95 cl:data-[side=bottom]:slide-in-from-top-2 cl:data-[side=left]:slide-in-from-right-2 cl:data-[side=right]:slide-in-from-left-2 cl:data-[side=top]:slide-in-from-bottom-2 cl:data-[state=closed]:animate-out cl:data-[state=closed]:fade-out-0 cl:data-[state=closed]:zoom-out-95",
          className
        )}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow className="cl:z-50 cl:size-2.5 cl:translate-y-[calc(-50%_-_2px)] cl:rotate-45 cl:rounded-[2px] cl:bg-foreground cl:fill-foreground" />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  )
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
